import React from 'react';
import { useTopicOverviewContext } from '../../context';
import TopicSlice from '../../../../organisms/topic_slice';
import StatusMessage from '@magoosh/gre/adaptive_prep_v1/lib/status_message';
import { TopicSliceProps } from '@magoosh/gre/adaptive_prep_v1/organisms/topic_slice/types';

export const VerbalContent: React.FC = () => {
  const { data, fetchData } = useTopicOverviewContext();

  React.useEffect(() => {
    fetchData('verbal');
  }, []);

  return data.verbal.length !== 0 ? (
    <>
      <h3>All Verbal Topics</h3>
      {data.verbal.map((topic) => (
        <>
          <TopicSlice
            key={topic.id}
            icon={`${topic.significanceLevel}Significance` as TopicSliceProps['icon']}
            {...topic}
            subsection="verbal"
          />
        </>
      ))}
    </>
  ) : (
    <StatusMessage headline="One Second!" text="We are looking for verbal topics" isColored={true} />
  );
};

export default VerbalContent;
